import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Modal from "react-modal";
import withErrorBoundary from "../../decorators/withErrorBoundary";
import {toggleModal} from "../../AC/modal";
import {
  modalSelector,
  conditionSelector,
  onPlatformSelector
} from "../../selectors";
import Uploader from "./Uploader";
import ImageIcon from "@material-ui/icons/ImageOutlined";
import AddIcon from "@material-ui/icons/Add";
import NoSsr from "@material-ui/core/NoSsr";
import Tooltip from "@material-ui/core/Tooltip";
import {withStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import classNames from "classnames";
import productSettings from "../../services/product-settings";

const styles = () => ({
  button: {
    backgroundColor: `#52abda`,
    height: `46px`,
    width: `100%`,
    boxShadow: `none`,
    borderRadius: `23px`,
    "&:hover": {
      opacity: `.8`,
      backgroundColor: `#52abda`
    },
    "&:active": {
      boxShadow: `none`
    }
  },
  vtb: {
    borderRadius: `4px`,
    backgroundColor: `#00AAFF`,
    color: `white`
  }
});

class AddingPicture extends PureComponent {
  static propTypes = {
    isModalOpen: PropTypes.bool,
    condition: PropTypes.object,
    toggleModal: PropTypes.func,
    classes: PropTypes.object,
    onPlatform: PropTypes.string
  };
  toggleModal = () => {
    this.props.toggleModal(`pictures`);
  };
  isDisabled = () => {
    const {
      condition: {product, side}
    } = this.props;
    const settings = productSettings[product];
    return (
      settings &&
      settings.permissions &&
      settings.permissions[side] &&
      !settings.permissions[side].image
    );
  };
  render() {
    const {isModalOpen, classes, onPlatform} = this.props;
    const disabled = this.isDisabled();
    return (
      <div className="add-picture">
        <NoSsr>
          <Tooltip
            title={disabled ? `Добавление фото недоступно` : `Добавьте фото`}
          >
            <div>
              <Button
                variant="contained"
                onClick={this.toggleModal}
                color="primary"
                disabled={disabled}
                className={classNames(
                  classes.button,
                  {
                    [classes.vtb]: onPlatform === `vtb`
                  }
                )}
              >
                <AddIcon />
                <span> Фото </span>
                <ImageIcon />
              </Button>
            </div>
          </Tooltip>
        </NoSsr>
        <Modal
          className="editor-modal editor-modal_full_height"
          overlayClassName="editor-modal-overlay"
          isOpen={isModalOpen}
          onRequestClose={this.toggleModal}
        >
          <Uploader />
          <button className="editor-modal__close" onClick={this.toggleModal}>
            ×
          </button>
        </Modal>
      </div>
    );
  }
}

Modal.setAppElement(`body`);

const mapStateToProps = (state) => ({
  isModalOpen: modalSelector(state, `pictures`),
  condition: conditionSelector(state),
  onPlatform: onPlatformSelector(state)
});

export default connect(mapStateToProps, {toggleModal})(
  withErrorBoundary(withStyles(styles)(AddingPicture))
);
